module.exports = __webpack_public_path__ + "aa68d325e402f985611689067cff3856.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/food/food2.png
// module id = 1952
// module chunks = 0